module.exports = __webpack_public_path__ + "static/media/CS1O1_EP4.0708117e.jpeg";